<template>
  <el-form :model="formData" ref="form" :rules="formRules">
    <el-row :gutter="20">
      <el-col :span="12">
        <el-checkbox v-model="formData.chop" :disabled="currentChop.chop != 0">{{ $t('chop.chop') }}</el-checkbox>
      </el-col>
      <el-col :span="12">
        <el-checkbox v-model="formData.license" :disabled="currentChop.license != 0">{{ $t('chop.license') }}</el-checkbox>
      </el-col>
      <el-col :span="12">
        <el-checkbox v-model="formData.licenseCopy" :disabled="currentChop.license_copy != 0">{{ $t('chop.license-copy') }}</el-checkbox>
      </el-col>
      <el-col :span="12">
        <el-checkbox v-model="formData.legalChop" :disabled="currentChop.legal_chop != 0">{{ $t('chop.legal-chop') }}</el-checkbox>
      </el-col>
      <el-col :span="24">
        <el-form-item :label="$t('chop.comment')" prop="comment">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4}"
            v-model.trim="formData.comment"
            style="width:100%">
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('chop.return-time')" prop="returnTime">
          <el-date-picker
              v-model="formData.returnTime"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              :placeholder="$t('vendor.contract.select-date')"
              style="width:100%"
              >
            </el-date-picker>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<style scoped>
</style>
<script>
import { Loading } from 'element-ui'

export default {
  name: 'ChopForm',
  props: ['le', 'currentChop'],
  data: function() {
  return {
    formData: {
        'id': null,
        'userId': null,
        'legalEntityId': null,
        'chop': false,
        'license': false,
        'licenseCopy': false,
        'legalChop': false,
        'comment': null,
        'returnTime': null
      },
    formRules: {
        'comment': [{required: true, message: this.$t('chop.validate.comment'), trigger: 'blur'}],
        'returnTime': [{required: true, message: this.$t('chop.validate.return'), trigger: 'blur'}]
    }
  }
  },
  computed: {
    
  },
  watch: {
    
  },
  methods: {
    applyChop: function() {
      //check selection
      if (!this.formData.chop && !this.formData.license && !this.formData.licenseCopy && !this.formData.legalChop) {
        this.$message({
          message: this.$t('chop.validate.select'),
          type: 'error'
        })
        return false
      }
      this.$refs.form.validate(valid => {
        if (valid) {
          //close model
          this.formData.legalEntityId = this.le
          this.formData.userId = localStorage.getItem('token')
          console.log(this.formData)
          let loading = Loading.service({ fullscreen: true }),
              that = this
          this.$http.post(this.API3_PREFIX + 'chop', this.formData).then(function (response) {
        that.$nextTick(() => {
        loading.close();
        })
            that.$message({
            message: that.$t('chop.success'),
            type: 'success'
          })
          that.$refs.form.resetFields()
          that.$emit('value-save', that.formData)
      }).catch(function (error) {
      console.log(error)
      that.$nextTick(() => {
        loading.close();
      })
      that.$message({
            message: that.$t('chop.failed'),
            type: 'error'
          })
        })
        } else {
          // do stuff if not valid.
          this.$message({
            message: this.$t('chop.invalid'),
            type: 'error'
          })
          return false
        }
      })
    }
  },
  created: function() {
    
  }
}
</script>